export default __webpack_public_path__ + "static/media/user-reg.3a19557a.svg";